import {useSelector} from "@/components/resume/redux/hooks";
import useResumeDetailInstance from "@/pages/ResumeDetail/hooks/useResumeDetailInstance";

export default () => {
    const resumeDetailInstance = useResumeDetailInstance()
    return useSelector(state => resumeDetailInstance.resumeRef.current?.version?.canPre);
}
